<template>
  <div style="padding: 15px 15px">
    <el-form :inline="true" class="demo-form-inline" :maxHeight="10" style="padding-top: 10px">
      <el-form-item :label="$t('Remaining times')">
        <el-tag type="success">{{ number }}</el-tag>
      </el-form-item>
      <el-form-item label="Token">
        <el-input v-model="token" show-password :placeholder="$t('No sharing token')"></el-input>
      </el-form-item>
      <el-form-item :label="$t('Pump contract')">
        <el-input v-model="pumpca" :placeholder="$t('Pump contract')" style="width: 400px"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="fetchData(0)">{{
          $t("Query")
          }}</el-button>
        <el-button type="primary" @click="fetchData(1)">{{
          $t("QueryProfit")
          }}</el-button>
        <a :href="pumpurl" target="_blank"><el-button type="primary">Pump</el-button></a>
        <a :href="gmgnai" target="_blank"><el-button type="primary">{{ $t("K-line") }}</el-button></a>
        <el-button type="primary" @click="openRemarksDialog">{{
          $t("Wallet remarks")
          }}</el-button>

        <!-- <el-dropdown @command="changeSelectType" trigger="click">
          <span class="el-dropdown-link">
            {{ selectType == "0" ? "Solana" : "ETH(测试中)"
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">Solana</el-dropdown-item>
             <el-dropdown-item command="1">ETH(测试中)</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

        <!-- <el-dropdown @command="changeLang" trigger="click">
          <span class="el-dropdown-link">
            {{ lang == "cn" ? "CN" : "EN"
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>CN</el-dropdown-item>
            <el-dropdown-item>EN</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->

        <a id="sunMoonSpan" @click="changetheme">
          <i class="el-icon-moon" :class="themeType == 'light' ? 'el-icon-sunny' : 'el-icon-moon'"></i>
        </a>
        <a href="https://t.me/XiGua_10086" target="_blank"><i class="el-icon-s-promotion"></i></a>
        <!-- <a href="https://t.me/XiGua_10086" target="_blank"
          ><i><img src="/static/img/icons8-m-100.png" style="width: 25px;height: 25px;" alt="图标" /></i
        ></a> -->

      </el-form-item>
    </el-form>

    <div style="margin-bottom: 10px">
      <el-avatar style="vertical-align: middle" :size="40" :src="caInfoMap.logo"></el-avatar>

      <span style="font-size: 13px">
        {{ $t("Currency") }}: {{ caInfoMap.symbol }}&emsp;&emsp;
        {{ $t("Owners") }}: {{ caInfoMap.holderCount }}&emsp;&emsp;
        {{ $t("5-mins-buy") }}:{{ caInfoMap.buyCount }}&emsp;&emsp;
        {{ $t("5-mins-sell") }}:{{ caInfoMap.sellCount }}&emsp;&emsp;
        {{ $t("Market cap") }}:{{ caInfoMap.marketCap }}&emsp;&emsp;
        {{ $t("Duration") }}:{{ caInfoMap.createMinutes }}&emsp;&emsp;
        {{ $t("mouseCount") }}:{{ mouseCount }}&emsp;&emsp;
        {{ $t("lowBalance") }}:{{ lowBalance }}&emsp;&emsp;
      </span>
 
      <span style="font-size: 13px ;display: block;">
        <span>DEV钱包：{{ caInfoMap.createBy }}</span>
        <el-button size="mini" round @click="copyValue(caInfoMap.createBy)">复制</el-button>
        <el-button type="text" @click="openDevlog">DEV资金来源</el-button>
        <el-button type="text" @click="goToTwitter(pumpca)">Twitter搜CA</el-button>
        <el-button type="text" @click="goToTwitter(caInfoMap.createBy)" >Twitter搜DEV</el-button>
      </span>
    </div>

    <!-- <div class="tables-container table-bottom">
      <el-table :data="wallerInfoList" v-loading="loading" max-height="250" :row-style="{ height: '0' }"
        :cell-style="{ padding: '5px' }" border class="table-left">
        <el-table-column prop="firstTimeFormat" :label="$t('')">
        </el-table-column>
        <el-table-column prop="lastTimeFormat" :label="$t('')">
        </el-table-column>
      </el-table>

      <el-table :data="formattedData" v-loading="loading" max-height="250" :row-style="{ height: '0' }"
        :cell-style="{ padding: '5px' }" border class="table-left">
       <el-table-column label="【匹配地址高重叠的CA】">
          <template slot-scope="scope">
            <a :href="`https://gmgn.ai/sol/token/${scope.row.key}` " target="_blank"
              :class="'link-color'">
              {{scope.row.key}}
            </a>
          </template>
        </el-table-column>
        <el-table-column label="重叠地址数量">
          <template slot-scope="scope">
              <a @click="openTokenDialog" target="_blank" :class="'link-color'">
                {{scope.row.wallerValue.length}}
              </a>
          </template>
        </el-table-column>
      </el-table>

      <el-card class="box-card" body-style="padding: 0;">
        <Plate v-if="data.length > 0" @graphClick="showDialog" containerId="graph_container"
          :graphSize="{ width: width, height: 250 }" :nodeSize="{ width: 50, height: 30 }" :data="data" />
        <template v-else>
          <div :style="{ width: width + 'px', height: '250px' }"></div>
        </template>
      </el-card>
    </div> -->

    <div>
      <el-table :data="topMapList" v-loading="loading" style="width: 100%" max-height="1000"
        :row-style="{ height: '0' }" :cell-style="{ padding: '0' }" :row-class-name="getRowClassName" border>
        <el-table-column prop="address" :label="$t('Top analysis')" width="280">
          <template slot-scope="scope">
            <a :href="`https://gmgn.ai/sol/address/${scope.row.address}`" target="_blank" :class="'link-color'">
              {{scope.row.address.substring(0, 4) + '....' + scope.row.address.substring(scope.row.address.length -8, scope.row.address.length)}}  {{ scope.row.isDevLog == true ? '(-创业怪)':''}}
            </a>
            <button style="height: 15px; width: 25px; border: none;border-radius: 30%;" @click="copyValue(scope.row.address)">
              <i >c</i>
           </button>
          </template>
        </el-table-column>
        <el-table-column prop="solBalance" :label="$t('No displaying if below 1')">
        </el-table-column>
        <el-table-column prop="amountResult" :label="$t('Proportion%')">
        </el-table-column>
        <el-table-column prop="from" :label="$t('Sources of recent funding')">
          <template slot-scope="scope">
            <a v-if="scope.row.isMouse == '1'"
              :href="`https://gmgn.ai/sol/address/${scope.row.from}`"
              target="_blank" :class="'link-color'">
              <span>{{isBreamkMap(scope.row.from)}}</span>
              <!-- <span>{{ scope.row.from.substring(0, 4) + '....' + scope.row.from.substring(scope.row.from.length -3, scope.row.from.length) }}</span> -->
            </a>
            <span v-if="scope.row.isMouse != '1'">
              {{ scope.row.from.substring(0, 8) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="钱包时长(天)" >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" :content='formatTimestamp(scope.row.firstTime)' placement="left">
              <span  :class="{ 'text-red': isConditionMet(scope.row.firstTime) }">
                {{ isConditionMet(scope.row.firstTime) ? daysBetween(scope.row.firstTime) +'（新）':daysBetween(scope.row.firstTime)}}
              </span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="formattedTime" :label="$t('Trade time')">
        </el-table-column>
        <el-table-column prop="holdMinutes" :label="$t('Hold minutes')">
          <template #header>
            <el-tooltip class="item" effect="dark" content="上一次买卖时间和当前时间差" placement="top">
              <span>交易时间差(分)</span>
            </el-tooltip>   
          </template>
        </el-table-column>
        <el-table-column prop="profitChangeResult" :label="$t('Profit(%)(no displaying if negative)')">
        </el-table-column>
        <el-table-column prop="buySell" :label="$t('Buy/Sell')">
        </el-table-column>
        <el-table-column prop="paperHand" :label="$t('PaperHand')">
          <template #header>
            <el-tooltip class="item" effect="dark" content="开启此功能会导致查询效率变慢并且扣除次数累加(-1)" placement="top">
              <el-checkbox v-model="handChecked"></el-checkbox>
            </el-tooltip>
              <span>持币均时(分)</span>
          </template>
        </el-table-column>
        <el-table-column prop="paperHandTokenNum" label="小时内购币数量">
          <template #header>
            <el-tooltip class="item" effect="dark" content="一小时内购买代币次数" placement="top">
              <span>小时内购币数量</span>
            </el-tooltip>   
          </template>
        </el-table-column>
        <el-table-column prop="paperHandToken" label="持币顺序">
        </el-table-column>        
        <el-table-column prop="boduanStr" :label="$t('Trading style')">
        </el-table-column>
        <el-table-column prop="remarks" :label="$t('Wallet remarks')">
        </el-table-column>
      </el-table>
    </div>

    <el-form :inline="true" class="demo-form-inline" :maxHeight="10" style="padding-top: 10px">
        <el-form-item :label="$t('钱包地址')">
          <el-input v-model="genDanAddress" :placeholder="$t('钱包地址')" style="width: 400px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="genDanData">{{
            $t("查询")
            }}</el-button>
        </el-form-item>
    </el-form>

    <div class="tables-container table-bottom">
         <el-table
          :data="genDanLogResponseList"
          v-loading="loading"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '5px' }"
          border
          class="table-left"
        >
          <el-table-column
            width="500"
            prop="fromAddress"
            :label="$t('钱包地址')"
          >
          <template slot-scope="scope">
            <span  :class="{ 'text-red': genDanMet(scope.row.fromAddress) }">
                {{ scope.row.fromAddress}}
              </span>
          </template>
          </el-table-column>
  
          <el-table-column
            prop="type"
            :label="$t('类型')"
          >
          </el-table-column>
          
          <el-table-column
            prop="format"
            :label="$t('时间')"
          >
          </el-table-column>

          <el-table-column
            prop="num"
            :label="$t('金额(sol)')"
          >
        </el-table-column>    
        
        <el-table-column
            prop="remarks"
            :label="$t('备注')"
          >
        </el-table-column>

          <el-table-column
            prop="hash"
            :label="$t('hash')"
          >
          <template slot-scope="scope">
            <a :href="`https://solscan.io/tx/${scope.row.hash}`" target="_blank" :class="'link-color'">
              {{'HASH'}}
            </a>
          </template>
          </el-table-column>
        </el-table>
      </div>
    

    <el-dialog :visible.sync="dialogVisible" width="1300px" center>
      <Plate v-if="dialogVisible" containerId="graph_dialog_container" :graphSize="{ width: 1300, height: 600 }"
        :nodeSize="{ width: 50, height: 30 }" :data="data" />
    </el-dialog>

    <el-dialog :visible.sync="remarkDialogShow" width="1000px" center close-on-click-modal v-if="remarkDialogShow">
      <el-table :data="remarkDialogData" border>
        <el-table-column :label="$t('Address')">
          <template slot-scope="scope">
            <el-input v-model="scope.row.key" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Remark')">
          <template slot-scope="scope">
            <el-input v-model="scope.row.value" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column :label="$t('Operation')">
          <template slot-scope="scope">
            <el-button type="text" style="color: red" @click="delDialogRemark(scope.row)">{{ $t("Delete") }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="margin-top: 20px" class="box box-center">
        <el-button type="text" @click="addDialogRemark()">{{ $t("New line") }}</el-button>
      </div>
      <div class="remarkSave">
        <el-button type="primary" @click="saveDialogRemark()">{{ $t("Save") }}</el-button>
      </div>
    </el-dialog>


    <el-dialog :visible.sync="tokenDialogShow" width="1000px" center close-on-click-modal v-if="tokenDialogShow">
      <el-table :data="formattedData" border>
        <el-table-column label="合约地址">
          <template slot-scope="scope">
            <a :href="`https://gmgn.ai/sol/token/${scope.row.key}` " target="_blank"
              :class="'link-color'">
              {{scope.row.key}}
            </a>
          </template>
        </el-table-column>
        <el-table-column label="重叠钱包地址">
          <template slot-scope="scope">
            <ul>
              <li v-for="value in scope.row.wallerValue" :key="value">
                <a :href="`https://gmgn.ai/sol/address/${value}`" target="_blank" :class="'link-color'">
                  {{value}}
                </a>
              </li>
            </ul>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog :visible.sync="devLogShow" width="1000px" center close-on-click-modal v-if="devLogShow">
      <el-table :data="caInfoMap.devLog" border>
        <el-table-column label="资金来源">
          <template slot-scope="scope">
            <a :href="`https://gmgn.ai/sol/address/${scope.row.from_address}` " target="_blank"
              :class="'link-color'">
              {{scope.row.from_address}}
            </a>
          </template>
        </el-table-column>
        <el-table-column  label="来源时间" >
          <template slot-scope="scope">
            <span>
                {{formatTimestamp(scope.row.block_time)}}
              </span>
          </template>
        </el-table-column>
        <el-table-column  label="金额(Sol)" >
          <template slot-scope="scope">
            <span>
                {{(scope.row.amount / 1000000000).toFixed(2)}}
              </span>
          </template>
        </el-table-column>
        <el-table-column  label="HASH" >
          <template slot-scope="scope">
            <span>
                <a :href="`https://solscan.io/tx/${scope.row.trans_id}`" target="_blank" :class="'link-color'">
                  {{'HASH'}}
                </a>
              </span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>




  </div>

  
</template>

<script>
import Plate from "./Plate";
import moment from 'moment';
export default {
  name: "mouse",
  components: { Plate },
  data() {
    return {
      number: "*",
      mouseCount: "*",
      newWalletCount: "*",
      lowBalance: "*",
      token: "",
      pumpca: "",
      caInfoMap: "",
      mouse: [],
      wallet: [],
      topMapList: [],
      wallerInfoList: [],
      tokenRelated: [],
      formattedData: [],
      goldenDogs: [],
      insideDishs: [],
      genDanLogResponseList: [],
      loading: false,
      pumpurl: "",
      gmgnai: "",
      bubble: "",
      selectApi: "",
      lang: this.$i18n.locale,
      selectType: 0,
      themeType: "dark",
      dialogVisible: false,
      width: window.innerWidth / 3,
      data: [],
      remarkDialogShow: false,
      tokenDialogShow: false,
      devLogShow: false,
      handChecked: false,
      genDanAddress: "",
      remarkDialogData: [],
      advertisementData: [
      { type: '通知群', remarks: 'PUMMMMM通知群', value: 'https://t.me/+A7-xO9jtMFNiZTI9' },
      { type: '燃烧频道', remarks: 'PUMMMMM燃烧频道', value: 'https://t.me/pumpfunburn' },
      { type: '交易机器人', remarks: 'GMGN交易机器人', value: 'https://t.me/GMGN_sol02_bot?start=i_dpBgGyGP' },
      { type: '交易机器人', remarks: 'Trojan交易机器人', value: 'https://t.me/diomedes_trojanbot?start=r-xigua_10086' },
      { type: '低保', remarks: '车费', value: 'https://claimyoursol.com/mHQfrqsXTnQRE9e1z3Nh' },
      ],
      retrievedMap: new Map()
    };
  },
  mounted() {
    this.loadData();
    this.goldenDog();
    this.httpGetRemarks();
    let themeClass = localStorage.getItem("theme");
    this.themeType = themeClass.split("-")[0];
    document.getElementById("app").setAttribute("class", themeClass);
  },
  methods: {
    genDanData() {
        this.loading = true;
        this.$axios
          .get("/api/genDanLog/" + this.genDanAddress.trim()+"/"+this.pumpca.trim()+"/"+this.token.trim())
          .then((successResponse) => {
            this.genDanLogResponseList = successResponse.data.map(item => {
            return {
              ...item,
              remarks: this.retrievedMap.get(item.fromAddress),
            };
          });
            this.loading = false;
          })
          .catch((failResponse) => {
            this.$message({
              message: failResponse.response.data,
              type: "error",
              duration: 2000,
            });
            this.loading = false;
            // 处理失败响应
          });
      },
    fetchData(e) {
      if (
        this.pumpca === null ||
        this.pumpca === undefined ||
        this.pumpca === ""
      ) {
        this.$message({
          message: this.$t("Please enter Solana contract"),
          type: "error",
          duration: 1000,
        });
        return;
      }
      if (
        this.token === null ||
        this.token === undefined ||
        this.token === ""
      ) {
        this.$message({
          message: this.$t("Please enter Token"),
          type: "error",
          duration: 1000,
        });
        return;
      }

      this.loading = true;
      this.selectApi = "/api/selectTop/";
      this.gmgnai = "https://gmgn.ai/sol/token/" + this.pumpca;
      this.pumpurl = "https://pump.fun/" + this.pumpca;
      /* if (this.selectType === '0') {
        this.selectApi = "/api/selectTop/";
        this.gmgnai = "https://gmgn.ai/sol/token/" + this.pumpca;
        this.pumpurl = "https://pump.fun/" + this.pumpca;
      } else {
        this.selectApi = "/api/selectEthTop/";
        this.gmgnai = "https://gmgn.ai/eth/token/" + this.pumpca;
        this.pumpurl = "https://gmgn.ai/eth/token/" + this.pumpca;
      } */

      localStorage.setItem("tokenTemp", this.token);
      localStorage.setItem("pumpcaTemp", this.pumpca);
      this.$axios
        .get(this.selectApi + this.token.trim() + "/" + this.pumpca.trim() + "/" + e +"/" + this.handChecked)
        .then((successResponse) => {
          this.number = successResponse.data.number;
          this.mouseCount = successResponse.data.mouseCount;
          this.newWalletCount = successResponse.data.newWalletCount;
          this.lowBalance = successResponse.data.lowBalance;
          this.mouse = successResponse.data.mouse;
          this.wallet = successResponse.data.wallet
          this.topMapList = successResponse.data.topMapList;
          this.wallerInfoList = successResponse.data.wallerInfoList;
          this.data = successResponse.data.sourMapList;
          this.topMapList = successResponse.data.topMapList.map(item => {
            return {
              ...item,
              remarks: this.retrievedMap.get(item.address),
              //from: item.from.substring(0, 8)
            };
          });

          this.loading = false;
        })
        .catch((failResponse) => {
          this.$message({
            message: failResponse.response.data,
            type: "error",
            duration: 2000,
          });
          this.loading = false;
          // 处理失败响应
        });

        
      this.$axios.get("/api/getCaInfo/" + this.token.trim() + "/" + this.pumpca.trim() + "/" + 0)
        .then((successResponse) => {
          let market = successResponse.data.marketCap;
          if (market < 1000) {
            successResponse.data.marketCap = market;
          } else {
            successResponse.data.marketCap = (market / 1000).toFixed(2) + "K";
          }
          this.caInfoMap = successResponse.data;
        })
        .catch((failResponse) => {
          // 处理失败响应
        });

        /* this.$axios.get("/api/matchCa/" + this.token.trim() + "/" + this.pumpca.trim())
        .then((successResponse) => {
          let arr = []
          Object.keys(successResponse.data).forEach(key1 => {
            console.log(key1 + ": " + successResponse.data[key1]);
           arr.push({
                key: key1,
                wallerValue: successResponse.data[key1]
          }) 
        });
          this.formattedData = arr; 
        })
        .catch((failResponse) => {
          // 处理失败响应
        }); */

    },
    goldenDog() {
      /*  this.timer = window.setInterval(() => {
         this.$axios
           .get("/api/goldenDog")
           .then((successResponse) => {
             this.goldenDogs = successResponse.data.goldenDog;
             this.insideDishs = successResponse.data.insideDish;
           })
           .catch((failResponse) => {
             // 处理失败响应
           });
       }, 4000); */
    },
    loadData() {
      this.token = localStorage.getItem("tokenTemp");
      this.pumpca = localStorage.getItem("pumpcaTemp");
      //this.selectType = localStorage.getItem("selectType");
    },
    getRowClassName({ row, index }) {
      if (row.isMouse === 1) {
        return "row-color-2";
      }
    },
    copyValue(symbol) {
      this.$message({
        message: this.$t("Copy successful"),
        type: "success",
        duration: 500,
      });
      navigator.clipboard
        .writeText(symbol)
        .then(function () { })
        .catch(function (err) { });
    },
    // 更换语言
    changeLang() {
      this.$i18n.locale = this.$i18n.locale == "cn" ? "en" : "cn"; //设置中英文模式
      this.lang = this.$i18n.locale;
      localStorage.setItem("lang", this.$i18n.locale);
    },
    // 选择查询类型
    /* changeSelectType(e) {
      this.selectType = e;
      localStorage.setItem("selectType", e);
    }, */

    changetheme() {
      // 选择span元素
      var $spanElement = document.getElementById("sunMoonSpan");
      // 选择span内部的i元素
      var $iElement = $spanElement.querySelector("i");
      this.themeType = this.themeType == "light" ? "dark" : "light";
      document
        .getElementById("app")
        .setAttribute("class", `${this.themeType}-theme`);
      localStorage.setItem("theme", `${this.themeType}-theme`);
    },
    showDialog() {
      this.dialogVisible = true;
    },
    openTokenDialog() {
      this.tokenDialogShow = true;
    },
    openDevlog() {
      this.devLogShow = true;
    },
    isConditionMet(firstTime){
      // 将 firstTime 转换为 Date 对象
    const firstTimeDate = new Date(firstTime * 1000);
    // 获取当前时间
    const currentTime = new Date();
    // 计算24小时之前的时间
    const twentyFourHoursAgo = new Date(currentTime - 24 * 60 * 60 * 1000);
    // 判断 firstTime 是否在当前时间的24小时之内
    return firstTimeDate >= twentyFourHoursAgo && firstTimeDate <= currentTime;
    },
    is7DayConditionMet(firstTime){
      // 将 firstTime 转换为 Date 对象
    const firstTimeDate = new Date(firstTime * 1000);
    // 获取当前时间
    const currentTime = new Date();
    // 计算24小时之前的时间
    const twentyFourHoursAgo = new Date(currentTime - 24 * 60 * 60 * 1000);
    //const twentyFourHoursAgo = new Date(currentTime - 168 * 60 * 60 * 1000);
    // 判断 firstTime 是否在当前时间的24小时之内
    return firstTimeDate >= twentyFourHoursAgo && firstTimeDate <= currentTime;
    },
    // 打开弹窗
    openRemarksDialog() {
      this.httpGetRemarks();
      this.remarkDialogShow = true;
    },
    // 添加
    addDialogRemark() {
      this.remarkDialogData.push({
        id: this.remarkDialogData.length + 1,
        key: "",
        value: "",
      });
    },
    // 删除
    delDialogRemark(item) {
      this.remarkDialogData.splice(this.remarkDialogData.findIndex(res => { return res.id == item.id }), 1);
    },
    // 保存
    saveDialogRemark() {
      let map = new Map();
      for (const item of this.remarkDialogData) {
        map.set(item.key, item.value);
      }
      this.retrievedMap = map;
      try {
        this.$axios.post('/api/savaRemarks', {
          token: this.token,
          remarks: JSON.stringify(this.remarkDialogData)
        });
      } catch (error) {
      }
      this.$message.success(this.$t("Save successful"));
    },
    httpGetRemarks() {
      this.$axios
        .get("/api/getRemarks/" + this.token)
        .then((successResponse) => {
          this.remarkDialogData = successResponse.data;
          let map = new Map();
          for (const item of this.remarkDialogData) {
            map.set(item.key, item.value);
          }
          this.retrievedMap = map;
        })
        .catch((failResponse) => {
          // 处理失败响应
        });
    },
    isBreamkMap(e) {
      let temp = this.retrievedMap.get(e);
      if(temp == null){
        return e.substring(0, 4) + '....' + e.substring(e.length -3, e.length)
      }else{
        return temp
      }
    },
    formatTimestamp(cellValue) {
      return moment(cellValue * 1000).format('YYYY-MM-DD HH:mm:ss');
    },
    formatTimestampMM(cellValue) {
      return moment(cellValue * 1000).format('MM-DD');
    },
    daysBetween(timestamp) {
    const now = Date.now();
    const differenceInMilliseconds = now - (timestamp * 1000);
    // 将差值转换为天数
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const differenceInDays = Math.floor(differenceInMilliseconds / millisecondsPerDay);
    return differenceInDays;
    },
    genDanMet(fromAddress){
        return this.genDanAddress === fromAddress
    },
    goToTwitter(e) {
      window.open('https://twitter.com/search?q='+e+'&f=live');
    }
  },
};
</script>

<style scoped>
.tables-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.text-red{
  color:#e39a9d;
}
.link-color {
  color: #409eff;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  margin-left: 30px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-icon-sunny {
  font-size: 25px;
  margin-left: 20px;
}

.el-icon-moon {
  font-size: 25px;
  margin-left: 20px;
}

.el-icon-s-promotion {
  margin-left: 25px;
  font-size: 30px;
}

.box-three {
  margin: 30px 0;
}

.table-left {
  margin-right: 15px;
}

.table-bottom {
  margin-bottom: 30px;
}

.remarkSave {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 30px;
}

.box {
  display: flex;
}

.box-column-center {
  justify-content: center;
}

.box-center {
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Mouse.vue